var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBazaWiedzy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 88.02 89.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:3px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M82.61,45.11c6.63-5.26,4.63-18.81-4.45-30.28C69.06,3.36,56.32-1.67,49.69,3.58c-6.04,4.79-4.92,16.47,2.2,27.17L2.11,70.22l4.76,6,4.24-3.36,11.24,14.18,4.32-3.43-11.24-14.18,7.45-5.9,11.24,14.18,4.32-3.43-11.24-14.18,29.46-23.35c8.8,9.38,19.92,13.14,25.96,8.35Zm-23.1-15.49c-5.86-7.39-7.63-15.73-3.95-18.64s11.4,.71,17.25,8.1c5.85,7.39,7.62,15.73,3.95,18.64s-11.39-.72-17.25-8.1Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBazaWiedzy);
export default __webpack_public_path__ + "static/media/bazaWiedzy.bc8ef65ba86d4aea1efc39546ef8039c.svg";
export { ForwardRef as ReactComponent };